import { Badge, Button, Flex, theme } from "antd";
import classNames from "classnames";
import {
  JumpStatus,
  NoticeItemType,
  ReadStatus,
} from "@/components/HeaderNotice/types";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useState } from "react";

interface NoticeItemProps {
  data: NoticeItemType;
  onRead: (data: NoticeItemType) => void;
  onJump: (data: NoticeItemType) => void;
}

const NoticeItem = ({ data, onRead, onJump }: NoticeItemProps) => {
  const { token: globalToken } = theme.useToken();
  const [expand, setExpand] = useState(false);
  const handleToggleExpand = () => {
    setExpand(!expand);
    if (!expand && data.is_reach === ReadStatus.UNREAD) {
      // 处理通知已读逻辑
      onRead(data);
    }
  };

  const handleJump = () => {
    onJump(data);
  };

  return (
    <div className="bg-white w-full rounded cursor-pointer">
      <div className="px-3" onClick={handleToggleExpand}>
        <div className="flex flex-row items-center justify-between mb-1">
          <span
            className={classNames(
              "text-sm font-bold",
              data.is_reach === ReadStatus.READ
                ? "text-[#999999]"
                : "text-[#333333]",
            )}
          >
            {data.is_reach === ReadStatus.UNREAD && (
              <Badge status="error" className="mr-1" />
            )}
            {data.message_title}
          </span>
          <div>
            <span
              className={classNames(
                "text-xs",
                data.is_reach === ReadStatus.READ
                  ? "text-[#cccccc]"
                  : "text-[#666666]",
              )}
            >
              {data.push_datetime}
            </span>
            {expand && (
              <span
                className="font-medium cursor-pointer ml-2"
                style={{ color: globalToken.colorPrimary }}
              >
                收起 <UpOutlined />
              </span>
            )}
          </div>
        </div>

        <div className="text-[13px] text-[#666666] leading-6 flex flex-row">
          <span
            className={classNames(
              "flex-1",
              expand ? "" : "line-clamp-1",
              data.is_reach === ReadStatus.READ
                ? "text-[#999999]"
                : "text-[#666666]",
            )}
          >
            {data.message_content}
          </span>
          {!expand && (
            <span
              className="font-medium cursor-pointer ml-2"
              style={{ color: globalToken.colorPrimary }}
            >
              展开 <DownOutlined />
            </span>
          )}
        </div>
      </div>
      {expand && (
        <Flex justify="flex-end" align="center" className="mt-2">
          {data.is_jump === JumpStatus.JUMP && (
            <Button type="link" size="small" onClick={handleJump}>
              立即查看
            </Button>
          )}
        </Flex>
      )}
    </div>
  );
};

export default NoticeItem;
